import {getShowFilesComponent} from "../../../components/ShowFiles/ShowFiles";

const prefix = `/assets/files/compare/summer`;

export const SummerCompare = getShowFilesComponent('Летние сравнительные таблицы', [
    `${prefix}/для внедорожников лето`,
    `${prefix}/для легковых автомобилей лето`,
]);